import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RegistrationSuccess = ({ userEmail, onClose }) => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          navigate('/user-dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleContinue = () => {
    navigate('/user-dashboard');
  };

  const handleResendEmail = () => {
    // Mock resend email functionality
    console.log('Resending verification email to:', userEmail);
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center z-50 animate-fade-in">
      <div className="bg-card border border-border rounded-lg shadow-lg p-8 max-w-md w-full mx-4 animate-scale-in">
        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center">
            <Icon name="CheckCircle" size={32} color="var(--color-success)" />
          </div>
        </div>

        {/* Success Message */}
        <div className="text-center space-y-4">
          <h3 className="text-2xl font-bold text-foreground">Welcome to BikeUpgrade Pro!</h3>
          <p className="text-muted-foreground">
            Your account has been created successfully. We've sent a verification email to{' '}
            <span className="font-medium text-foreground">{userEmail}</span>
          </p>
        </div>

        {/* Next Steps */}
        <div className="mt-6 p-4 bg-muted/50 rounded-lg">
          <h4 className="font-semibold text-foreground mb-2">What's next?</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li className="flex items-center space-x-2">
              <Icon name="Mail" size={16} color="var(--color-accent)" />
              <span>Check your email and verify your account</span>
            </li>
            <li className="flex items-center space-x-2">
              <Icon name="Camera" size={16} color="var(--color-accent)" />
              <span>Upload your first bike photo</span>
            </li>
            <li className="flex items-center space-x-2">
              <Icon name="Zap" size={16} color="var(--color-accent)" />
              <span>Get personalized upgrade recommendations</span>
            </li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="mt-6 space-y-3">
          <Button
            variant="default"
            size="lg"
            fullWidth
            onClick={handleContinue}
            iconName="ArrowRight"
            iconPosition="right"
          >
            Continue to Dashboard ({countdown}s)
          </Button>

          <div className="flex space-x-3">
            <Button
              variant="outline"
              size="sm"
              onClick={handleResendEmail}
              iconName="Mail"
              iconPosition="left"
              className="flex-1"
            >
              Resend Email
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="flex-1"
            >
              Close
            </Button>
          </div>
        </div>

        {/* Help Text */}
        <div className="mt-4 text-center">
          <p className="text-xs text-muted-foreground">
            Didn't receive the email? Check your spam folder or{' '}
            <button 
              onClick={handleResendEmail}
              className="text-accent hover:underline"
            >
              resend verification email
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;